import {
  RaDashboardScreen,
  RaFindingsScreen,
  RaLibraryScreen,
  RaMasterDataScreen,
  RaRegisterScreen,
  RaReportsScreen,
  RaVerificationScreen,
  RiskAssessmentScreen,
  raFindingsRoute,
  riskLinkOf,
} from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Shell } from '../components/Shell.js';
import {
  officeRaDashboardSource,
  officeRaFindingSource,
  officeRaLibrarySource,
  officeRaMasterSource,
  officeRaRegisterSource,
  officeRaVerificationSource,
  officeRiskSource,
} from '../risk-source.js';

/** Compliance ▸ Risk Assessment (M13d; ADR 0050): filo listesi, ofis adımı, şablon kütüphanesi. */
export function RiskAssessmentPage() {
  const { t } = useTranslation();
  // Panodaki iş satırı `?vessel=&id=` (ADR 0156)
  const { search } = useLocation();
  return (
    <Shell title={t('menu.complianceRiskAssessment')}>
      <RiskAssessmentScreen source={officeRiskSource} initialId={riskLinkOf(search).id} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Master Data (K2; ADR 0086): şirketin risk ana verisi. */
export function RiskMasterDataPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.complianceRiskMasterData')}>
      <RaMasterDataScreen source={officeRaMasterSource} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Library (K3; ADR 0087): şirket RA kütüphanesi. */
export function RiskLibraryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.complianceRiskLibrary')}>
      <RaLibraryScreen source={officeRaLibrarySource} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Vessel Risk Register (K4; ADR 0088): ofiste salt okunur. */
export function RiskRegisterPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.complianceRiskRegister')}>
      <RaRegisterScreen source={officeRaRegisterSource} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Operational Verification (K5; ADR 0089): ofiste salt okunur. */
export function RiskVerificationPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  return (
    <Shell title={t('menu.complianceRiskVerification')}>
      <RaVerificationScreen
        source={officeRaVerificationSource}
        initialId={new URLSearchParams(search).get('id')}
      />
    </Shell>
  );
}

/**
 * Compliance ▸ Risk Assessment ▸ Findings & Actions (K6; ADR 0094): bulgular salt okunur; DPA
 * yükseltmeyi, kütüphanenin gözden geçireni RA değişiklik talebini karara bağlar.
 */
export function RiskFindingsPage() {
  const { t } = useTranslation();
  const { search } = useLocation();
  return (
    <Shell title={t('menu.complianceRiskFindings')}>
      <RaFindingsScreen source={officeRaFindingSource} route={raFindingsRoute(search)} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Dashboard (K7; ADR 0095): filo ya da seçilen gemi. */
export function RiskDashboardPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.complianceRiskDashboard')}>
      <RaDashboardScreen source={officeRaDashboardSource} />
    </Shell>
  );
}

/** Compliance ▸ Risk Assessment ▸ Monitoring & Reports (K7; ADR 0095): raporlar ve CSV. */
export function RiskReportsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.complianceRiskReports')}>
      <RaReportsScreen source={officeRaDashboardSource} />
    </Shell>
  );
}
